import axios from "axios";
import swal from "sweetalert";

import { InitPage } from "../../index";

declare var client_code: string;
declare var store_code: string;

class PrintAction {
  constructor() {
    const _this = this;
    $("document").ready(function () {
      $('#submit-print_action-form').val('Print');

      $('.radios-field').on('click', function () {
        $('#submit-print_action-form').val($(this).attr('data-val'));
      });

      $("input[name='so_processes']").on("change", function (e: any) {
        const checked = e.currentTarget.checked
        $("input[name='so_process[]']").prop('checked', checked);
        $("#bulk_print_action_btn").prop("disabled", !checked);
      });

      $("input[name='so_process[]']").on("change", function () {
        const disabled = !$("input[name='so_process[]']:checked").val();
        $("#bulk_print_action_btn").prop("disabled", disabled);

        const checkedAll = $("input[name='so_process[]']").length == $("input[name='so_process[]']:checked").length
        $("input[name='so_processes']").prop('checked', checkedAll);
      });

      $("#bulk_print_action_btn").on("click", function () {
        $("#bulk-print-action-modal").modal("show");
      });

      $("#bulk_print_action_form").on("submit", function (event) {
        event.preventDefault();
        const ids = _this.getSoProcesses();
        if (!ids.length) return;

        const printer = $('#printer').val();
        const copies = $('#input_copies').val();

        switch ($("input[name='action_type']:checked").val()) {
          case "print_bol":
            _this.printBol(ids, printer, copies);
            break;

          case "preview_bol":
            _this.previewBol(ids, printer, copies)
            break;

          case "print_pallet_lic":
            _this.printPalletLic(ids, printer, copies);
            break;

          case "preview_pallet_lic":
            _this.previewPalletLic(ids, printer, copies)
            break;

          case "print_invoice":
            _this.printInvoice(ids, printer, copies);
            break;

          case "preview_invoice":
            _this.previewInvoice(ids, printer, copies)
            break;

          default:
            return;
        }

      });
    });
  }

  getSoProcesses() {
    const ids = []
    $("input[name='so_process[]']:checked").each(function () {
      ids.push($(this).val());
    });
    return ids;
  }

  printBol(ids: Array<string>, printer: string | number | string[], copies: string | number | string[]) {
    const promises = []
    const _this = this;
    ids.forEach((id: string, index: number) => {
      setTimeout(() => {
        promises.push(_this.performPrintBol(id, printer, copies));
      }, index * 2000);
    });
    this.performPrintPromise(promises);
  }

  previewBol(ids: Array<string>, printer: string | number | string[], copies: string | number | string[]) {
    ids.forEach((id: string) => {
      window.open(`/${client_code}/${store_code}/api/v1/printing/so-zone-cover/${printer}.pdf?soProcessId=${id}&copies=${copies}`, '_blank');
    });

    $("#bulk-print-action-modal").modal("hide");
  }

  printPalletLic(ids: Array<string>, printer: string | number | string[], copies: string | number | string[]) {
    const promises = []
    const _this = this;
    ids.forEach((id: string, index: number) => {
      setTimeout(() => {
        promises.push(_this.performPrintPalletLic(id, printer, copies));
      }, index * 2000);
    });
    this.performPrintPromise(promises);
 }

  previewPalletLic(ids: Array<string>, printer: string | number | string[], copies: string | number | string[]) {
    ids.forEach((id: string) => {
      window.open(`/${client_code}/${store_code}/api/v1/printing/so-zone-pallet-license/${printer}.pdf?soProcessId=${id}&copies=${copies}`, '_blank');
    });

    $("#bulk-print-action-modal").modal("hide");
  }

  printInvoice(ids: Array<string>, printer: string | number | string[], copies: string | number | string[]) {
    const promises = []
    const _this = this;
    ids.forEach((id: string, index: number) => {
      setTimeout(() => {
        promises.push(_this.performPrintInvoice(id, printer, copies));
      }, index * 2000);
    });
    this.performPrintPromise(promises);
  }

  previewInvoice(ids: Array<string>, printer: string | number | string[], copies: string | number | string[]) {
    ids.forEach((id: string) => {
      window.open(`/${client_code}/${store_code}/api/v1/printing/so-zone-invoice/${printer}.pdf?soProcessId=${id}&copies=${copies}`, '_blank');
    });

    $("#bulk-print-action-modal").modal("hide");
  }

  async performPrintBol(id: string, printer: string | number | string[], copies: string | number | string[]) {
    const instance = axios.create({ withCredentials: true });
    return instance.get(`/${client_code}/${store_code}/manufacturing/so_to_zone_processes/print_so_bol?id=${id}&printer=${printer}&copies=${copies}`);
  }

  async performPrintPalletLic(id: string, printer: string | number | string[], copies: string | number | string[]) {
    const instance = axios.create({ withCredentials: true });
    return instance.post(`/${client_code}/${store_code}/manufacturing/so_to_zone_processes/print_pallet_lic`, {
      authenticity_token: $("#bulk_print_action_form input[name='authenticity_token']").val(),
      id: id,
      printer: printer,
      copies: copies
    });
  }

  async performPrintInvoice(id: string, printer: string | number | string[], copies: string | number | string[]) {
    const instance = axios.create({ withCredentials: true });
    return instance.get(`/${client_code}/${store_code}/manufacturing/so_to_zone_processes/print_invoice?id=${id}&printer=${printer}&copies=${copies}`);
  }

  performPrintPromise(promises: Array<any>) {
    Promise.all(promises)
      .then(() => {
        swal.close();
        swal({
          title: "Success",
          text: 'All the prints initiated',
          icon: "success",
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "Close",
              value: null,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-silver",
              closeModal: true,
            }
          },
        }).then(() => {
          location.reload();
        });
      })
      .catch((error) => {
        swal.close();
        swal({
          title: "Error",
          text: error.message,
          icon: "error",
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "Close",
              value: null,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-silver",
              closeModal: true,
            }
          },
          dangerMode: true,
        });
      });

    $("#bulk-print-action-modal").modal("hide");
    swal({
      title: "Print(s) are in progress",
      closeOnClickOutside: false,
    });
  }
}

export function LoadPage() {
  InitPage("so_to_zone_processes steps", () => {
    new PrintAction();
  });
}
